import "@/bind/index";

import "./index.scss";
import { Shielding } from "@/core/Shielding";

declare global {
  interface Window {
    $shielding: Shielding;
  }
}

const $shielding = new Shielding();
window.$shielding = $shielding;

// window.onload = function (): void {
//   console.log("Shield ready");
//   const isA = $shielding.isAuth("15132897936");
//
//   if (!isA) {
//     $shielding.show();
//   }
// };
// http://dev-local.smarket.net.cn/project/shide-927-bjsn-202008130013-template/app_pc/common/html/meetingInfo.html?instanceId=958371&webinarId=140653&customFormId=2510230345659882&trackId=2:74&linkId=353573&tenantId=927&sourceKey=webinar_140653&sourceKey=webinar_140653
export default $shielding;
